/**
 * Product reviews carousel — random reviewer meta + dot sync.
 */
(function () {
  var firstNames = [
    'Oliver', 'Harry', 'George', 'Noah', 'Arthur', 'Leo', 'James', 'Emma', 'Sophie', 'Amelia',
    'Olivia', 'Isla', 'Ava', 'Charlotte', 'Mia', 'William', 'Thomas', 'Ethan', 'Daniel', 'Jessica'
  ];
  var lastNames = [
    'Smith', 'Jones', 'Taylor', 'Brown', 'Wilson', 'Evans', 'Thomas', 'White', 'Martin', 'Clark',
    'Roberts', 'Johnson', 'Lewis', 'Walker', 'Hall', 'Allen', 'Young', 'King', 'Wright', 'Scott'
  ];
  var places = [
    { city: 'London', country: 'UK', flag: '\uD83C\uDDEC\uD83C\uDDE7' },
    { city: 'Manchester', country: 'UK', flag: '\uD83C\uDDEC\uD83C\uDDE7' },
    { city: 'Birmingham', country: 'UK', flag: '\uD83C\uDDEC\uD83C\uDDE7' },
    { city: 'New York', country: 'USA', flag: '\uD83C\uDDFA\uD83C\uDDF8' },
    { city: 'Toronto', country: 'Canada', flag: '\uD83C\uDDE8\uD83C\uDDE6' },
    { city: 'Sydney', country: 'Australia', flag: '\uD83C\uDDE6\uD83C\uDDFA' },
    { city: 'Berlin', country: 'Germany', flag: '\uD83C\uDDE9\uD83C\uDDEA' },
    { city: 'Paris', country: 'France', flag: '\uD83C\uDDEB\uD83C\uDDF7' }
  ];
  var jobs = [
    'Teacher', 'Nurse', 'Retail manager', 'Runner', 'Office worker', 'Physiotherapist', 'Chef',
    'Engineer', 'Parent', 'Hiker', 'Accountant', 'Designer', 'Student', 'Marathon runner'
  ];
  var cardRatings = [4, 4.5, 5];

  function rnd(a, b) {
    return Math.floor(Math.random() * (b - a + 1)) + a;
  }

  function pick(arr) {
    return arr[rnd(0, arr.length - 1)];
  }

  function setStars(container, rating) {
    if (!container) return;
    var stars = container.querySelectorAll('.product-reviews__star');
    stars.forEach(function (star, index) {
      star.classList.remove(
        'product-reviews__star--full',
        'product-reviews__star--half',
        'product-reviews__star--empty'
      );
      var idx = index + 1;
      if (rating >= idx) star.classList.add('product-reviews__star--full');
      else if (rating >= idx - 0.5) star.classList.add('product-reviews__star--half');
      else star.classList.add('product-reviews__star--empty');
    });
  }

  function setActiveDot(dots, index) {
    dots.forEach(function (dot, i) {
      var on = i === index;
      dot.classList.toggle('is-active', on);
      dot.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  function setCounter(section, index, total) {
    var currentEl = section.querySelector('.js-pr-counter-current');
    if (currentEl) currentEl.textContent = String(index + 1);
  }

  function setActiveIndex(section, slider, slides, dots, index) {
    index = Math.max(0, Math.min(index, slides.length - 1));
    setActiveDot(dots, index);
    setCounter(section, index, slides.length);
  }

  window.initProductReviews = function (section) {
    if (!section) return;

    var slider = section.querySelector('[id^="Slider-ProductReviews-"]');
    var slides = section.querySelectorAll('.product-reviews__slide');
    var dots = section.querySelectorAll('.js-pr-dot');
    if (!slider || slides.length === 0) return;

    slides.forEach(function (slide) {
      var place = pick(places);
      var nameEl = slide.querySelector('.js-pr-name');
      var metaEl = slide.querySelector('.js-pr-meta');
      var starsEl = slide.querySelector('.js-pr-card-stars');

      if (nameEl) nameEl.textContent = pick(firstNames) + ' ' + pick(lastNames);
      if (metaEl) metaEl.textContent = place.flag + ' ' + place.city + ', ' + place.country + ' · ' + pick(jobs);

      if (starsEl) {
        var rating = pick(cardRatings);
        starsEl.setAttribute('data-rating', String(rating));
        setStars(starsEl, rating);
      }
    });

    function scrollToIndex(index) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      var slide = slides[index];
      if (!slide) return;
      slider.scrollTo({ left: slide.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
      setActiveIndex(section, slider, slides, dots, index);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-index'), 10);
        if (!isNaN(idx)) scrollToIndex(idx);
      });
    });

    var scrollTimer;
    slider.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var mid = slider.scrollLeft + slider.clientWidth / 2;
        for (var j = 0; j < slides.length; j++) {
          var s = slides[j];
          if (s.offsetLeft - slider.offsetLeft + s.offsetWidth / 2 >= mid) {
            setActiveIndex(section, slider, slides, dots, j);
            return;
          }
        }
        setActiveIndex(section, slider, slides, dots, slides.length - 1);
      }, 50);
    });

    slider.addEventListener('slideChanged', function (e) {
      var idx = e.detail && e.detail.currentPage != null ? e.detail.currentPage - 1 : 0;
      setActiveIndex(section, slider, slides, dots, idx);
    });

    setActiveIndex(section, slider, slides, dots, 0);
  };

  document.querySelectorAll('.product-reviews').forEach(window.initProductReviews);
})();
